import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import instance from "./utils/http";
import utils from "./utils/utils";
import { initRem } from "@/utils/setRem";
import "@/assets/style/bootstrap.css";
import "@/assets/style/css.css";
import "@/assets/style/switch.less";
import "@/assets/style/markdown.css";

// 尽早写入根字号，避免首屏闪一下大尺寸
initRem();
// import dragVerify from 'vue-drag-verify2'
import {
  hasPermission,
  getRoleId,
  nonNullCheck,
  isCurrentUser,
  getId,
  getClientId
} from "@/utils/permission";
import {
  getAccountRole,
  isManager,
  canCreateProjectGroup,
  isSuperAdmin,
  isLevelOneAdmin,
  isLevelTwoAdmin,
  isMember,
} from "@/utils/accountRole";

Vue.prototype.$hasPermission = hasPermission;
Vue.prototype.$nonNullCheck = nonNullCheck;
Vue.prototype.$getRoleId = getRoleId;
Vue.prototype.$getId = getId;
Vue.prototype.$getClientId = getClientId;
Vue.prototype.$isCurrentUser = isCurrentUser;
Vue.prototype.$getAccountRole = getAccountRole;
Vue.prototype.$isManager = isManager;
// 新建项目组：仅超管 / 管理员 / 子管理员
Vue.prototype.$canCreateProjectGroup = canCreateProjectGroup;
// 企业四级账号：超管 / 一级 / 二级分别判断，不再使用旧 ADMIN
Vue.prototype.$isSuperAdmin = isSuperAdmin;
Vue.prototype.$isLevelOneAdmin = isLevelOneAdmin;
Vue.prototype.$isLevelTwoAdmin = isLevelTwoAdmin;
Vue.prototype.$isMember = isMember;
Vue.config.productionTip = false;
Vue.prototype.$axios = instance;
Vue.prototype.$utils = utils;
// Vue.use(dragVerify)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

// 设置 favicon
function setFavicon(icon) {
  let link = document.querySelector("link[rel='icon']");

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  // 防止浏览器缓存
  link.href = icon + "?v=" + Date.now();
}

// 从 Vuex 获取 logoImage
const logoImage = store.state.logoImage;

console.log("logoImage =", logoImage);

if (logoImage === "logo-manyu") {

  setFavicon("/manyu.ico");
} else if (logoImage === "logo-shenglianyun") {

  setFavicon("/shenglianyun.ico");
} else if (logoImage === "logo-xinxixi") {

  setFavicon("/xinxixi.ico");
}else if (logoImage === "logo-lao-bin") {

  setFavicon("/lao-bin.ico");
}

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
